import { useState } from "react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Thank you for subscribing!");
      setEmail("");
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error("This email is already subscribed.");
      } else {
        toast.error("Failed to subscribe. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-3 w-full max-w-md" data-testid="newsletter-form">
      <Input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 bg-slate-800 border-slate-700 text-white placeholder:text-slate-400 focus:border-[#0056D2] h-12"
        required
        data-testid="newsletter-email-input"
      />
      <Button 
        type="submit" 
        disabled={loading}
        className="bg-[#0056D2] hover:bg-[#0044A5] text-white px-6 h-12 rounded-lg"
        data-testid="newsletter-submit-btn"
      >
        {loading ? (
          <div className="spinner w-5 h-5 border-2" />
        ) : (
          <Send className="w-5 h-5" />
        )}
      </Button>
    </form>
  );
};

export default NewsletterForm;
